/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

export const BASE_URL_API = '/api';
export const BASE_URL_ADMINISTRES = `${BASE_URL_API}/administres`;
export const BASE_URL_ETATCIVIL = `${BASE_URL_ADMINISTRES}/etat-civil`;

/** Sous-types d'acte de naissance, filtrés par code justice (comportement historique, en dur). */
export const URL_SOUS_TYPES_ACTE_NAISSANCE = `${BASE_URL_ETATCIVIL}/sous-type-actes?codeJustice=in(N,APN,ACN,CCN,DCN,JDN,JAP,PVET)`;

/** Sous-types d'acte de DÉCÈS, filtrés par code justice. */
export const URL_SOUS_TYPES_ACTE_DECES = `${BASE_URL_ETATCIVIL}/sous-type-actes?codeJustice=in(D,T,ESV,JDD,JDA)`;

/** Sous-types d'acte de MARIAGE, filtrés par code justice. */
export const URL_SOUS_TYPES_ACTE_MARIAGE = `${BASE_URL_ETATCIVIL}/sous-type-actes?codeJustice=in(M,P,RVC)`;

/**
 * Référentiel `ec_etamat` (état matrimonial du défunt).
 *
 * ⚠️ `?type=D_DEFUNT` est OBLIGATOIRE : la table couvre plusieurs contextes
 * (parents du défunt, époux d'un mariage…) et proposerait des états hors sujet.
 *
 * ⚠️ C'est `codeJustice` qui est stocké sur l'acte, jamais l'`id` — et deux
 * lignes de ce filtre partagent le même code, d'où le dédoublonnage côté hook.
 */
export const URL_ETATS_MATRIMONIAUX = `${BASE_URL_ETATCIVIL}/etats-matrimoniaux?type=D_DEFUNT`;

/**
 * Référentiel `ec_etamat`, contexte des conjoints d'un mariage : quatre
 * situations antérieures — célibataire, divorcé(e), pacsé(e), veuf(ve). Pas de
 * « marié(e) », qui n'a pas de sens avant un mariage.
 *
 * ⚠️ La barre oblique du nom de contexte est ENCODÉE (`%2F`). Elle passe aussi
 * en clair aujourd'hui, mais un caractère de chemin non encodé dans une valeur
 * de paramètre ne survit pas à tous les intermédiaires.
 */
export const URL_ETATS_MATRIMONIAUX_CONJOINT = `${BASE_URL_ETATCIVIL}/etats-matrimoniaux?type=M_EPX%2FEPSE`;

/**
 * Référentiel `ec_etamat`, contexte des parents (et témoins) d'un mariage.
 *
 * Contexte distinct de celui des conjoints, et plus large : « marié(e) » et
 * « séparé(e) » n'existent que là. Même remarque sur l'encodage.
 */
export const URL_ETATS_MATRIMONIAUX_PARENTS_MARIAGE = `${BASE_URL_ETATCIVIL}/etats-matrimoniaux?type=M_PAR%2FTEM`;

/**
 * Référentiel des professions de l'état civil : `ec_abreviation` restreinte au
 * type `EMPLOI` côté API, en lecture seule.
 *
 * ⚠️ Ce n'est PAS `/api/transverse/professions` (`ol_professions`), qu'utilise le
 * recensement citoyen : autre table, autre domaine, et création assumée là-bas.
 */
export const URL_PROFESSIONS = `${BASE_URL_ETATCIVIL}/professions`;

/** Référentiel 'ec_mmact' (mentions d'un acte) */
export const URL_MENTIONS = `${BASE_URL_ETATCIVIL}/mentions`;

/** Référentiel `ec_typrec` (sous-type d'acte de reconnaissance : N/V/D). */
export const URL_TYPES_RECONNAISSANCE = `${BASE_URL_ETATCIVIL}/types-reconnaissance`;

/** Référentiel `ec_autrec` (auteur de la reconnaissance : P/M/PM). */
export const URL_AUTORITES_RECONNAISSANCE = `${BASE_URL_ETATCIVIL}/autorites-reconnaissance`;

/**
 * Dossiers de numérisation, base des fiches (`useFiche` y concatène
 * `/{identifiant}` en lecture comme en écriture).
 */
export const URL_NUMERISATION_NAISSANCE = `${BASE_URL_ETATCIVIL}/numerisation-actes/naissance`;
export const URL_NUMERISATION_RECONNAISSANCE = `${BASE_URL_ETATCIVIL}/numerisation-actes/reconnaissance`;
export const URL_NUMERISATION_DECES = `${BASE_URL_ETATCIVIL}/numerisation-actes/deces`;
export const URL_NUMERISATION_MARIAGE = `${BASE_URL_ETATCIVIL}/numerisation-actes/mariage`;

/**
 * Endpoint générique des individus d'acte (`ec_acte_individu`), utilisable quel
 * que soit le type d'acte — contrairement au PUT du dossier de numérisation.
 */
export const URL_ACTE_INDIVIDUS = `${BASE_URL_ETATCIVIL}/acte-individus`;

/**
 * Lieux d'acte (`ec_acte_adresse`), endpoint générique.
 *
 * Seul chemin pour corriger un lieu depuis une fiche : le PUT du dossier de
 * numérisation ne touche que les colonnes de l'acte, et un lieu est une ligne à
 * part — celle du mariage y est écrite par `ModalEvenementMariage`.
 */
export const URL_ACTE_ADRESSES = `${BASE_URL_ETATCIVIL}/acte-adresses`;

/**
 * Documents rattachés aux actes (`ec_documents`).
 *
 * ⚠️ Index filtré et non `documents/acte/{id}` : cette route ne filtre que sur
 * `dc_idacte` et renverrait les documents d'un acte d'un AUTRE type portant le
 * même identifiant.
 */
export const URL_DOCUMENTS = `${BASE_URL_ETATCIVIL}/documents`;
